import { render, staticRenderFns } from "./HrPerfPromiseCheck.vue?vue&type=template&id=07706018&scoped=true&"
import script from "./HrPerfPromiseCheck.vue?vue&type=script&lang=js&"
export * from "./HrPerfPromiseCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07706018",
  null
  
)

export default component.exports